import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import { LOCALE } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
const ValidationInfo = t0 => {
    const $ = _c(13);
    const { buttonLabel } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== translate) {
        t1 = translate("messages.terms_and_condition_service");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const cgu = t1;
    let t2;
    if ($[2] !== buttonLabel || $[3] !== translate) {
        t2 = translate("validation_page.cgu_warning.rdv.start", {
            buttonLabel
        });
        $[2] = buttonLabel;
        $[3] = translate;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    const startOfSentence = t2;
    let t3;
    if ($[5] !== translate) {
        t3 = translate("validation_page.cgu_warning.rdv.end");
        $[5] = translate;
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    const endOfSentence = t3;
    const href = `/doc/CGU-widget-${LOCALE}.pdf`;
    let t4;
    if ($[7] !== cgu) {
        t4 = <Link href={href} externalLink={true} className="link-primary">{cgu}</Link>;
        $[7] = cgu;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== endOfSentence || $[10] !== startOfSentence || $[11] !== t4) {
        t5 = <p className="tunnel-margin-x-reduced-lg text-xs text-gray-400 mb-6 lgxl:mb-2">{startOfSentence}{t4}{endOfSentence}</p>;
        $[9] = endOfSentence;
        $[10] = startOfSentence;
        $[11] = t4;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    return t5;
};
export default ValidationInfo;
